import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import "react-notifications-component/dist/theme.css";
import i18n from '../i18n';
import {connect} from 'react-redux';
import {reactLocalStorage} from 'reactjs-localstorage';
import Menutest from './menu.js';
import Select from "react-select";
import {Checkbox} from 'semantic-ui-react';
import { API_BASE_URL } from "../utils/endpoints";
var type=''
  class AddRequestBalance extends React.Component {

    constructor(props) {
       super(props);
       this.state = {
         type_request:[
           { label: i18n.t('Sender_ID.label') , value: "Sender ID" },
           { label: i18n.t('Balance.label'), value: "Balance" }
          ],
          type_request_admin:[
            { label: i18n.t('Sender_ID.label'), value: "Sender ID" },

           ],
        type: [
            { label: "Bulk SMS", value: "bulk_sms" },
            { label: "Profiled SMS", value: "profiled" },
            { label: "LBA SMS", value: "lba" },
            { label: "Survey SMS", value: "survey" },
            { label: "International SMS", value: "international" },
        ],
        balance:0,
        typeselect:'',
        request: '',
        enable:false,
        isArabic:false,
        show:false

       }
     }

     handleChangebalance =event =>{
        this.setState({balance:event.target.value});
    }
componentWillMount(){
  var lang=i18n.language;
           if(lang ==="ar")
           {
             this.setState({isArabic:true})
           }

}
    componentDidMount(){

      if(reactLocalStorage.get('role') ==='ROLE_ADMIN')
      {
       document.querySelector('.type_request_admin').style = 'display:block';
       document.querySelector('.type_request').style = 'display:none';

      }
      else if(reactLocalStorage.get('role') ==='ROLE_SUBADMIN')

      {
        document.querySelector('.type_request_admin').style = 'display:none';
       document.querySelector('.type_request').style = 'display:block';
      }
           var lang=i18n.language;
           if(lang ==="ar")
           {
             document.querySelector('.title_req').style = 'float:right;';
             document.querySelector('.black_color').style = 'text-align:right;';
             document.querySelector('.checkbox').style = 'float: right;';
             document.querySelector('.type_ar').style = 'text-align:right;';
             document.querySelector('.balance_ar').style = 'float:right;';
           }



    }


    handleChange = event =>
    {
          this.setState({ request: event.target.value});
    }


    onChange = values => {
        this.setState({typeselect:values.value});

    }




handleSubmit = event =>
{
        event.preventDefault();
        var data;
        if(type ==="balance")
        {
            data={
          "type": "balance",
          "balance_type":this.state.typeselect,
          "value": this.state.balance
      };
        }
        else if(type==="sender_id")
        {
            data={
          "type": "sender_id",
          "value": this.state.request,
          "isAdv":this.state.enable
      };
        }
        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/request";
        }
        else
        {
        apiBaseUrl = API_BASE_URL+"/core/corpsms/request";
        }
        var headers = {
        'Content-Type': 'application/json',
        'token':token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {

        if(response.status === 200)
        {
          if(response.data.status === "success"){

         window.location="RequestBalance";
          }



        }
        else if(response.status === 204){
        console.log("Something wrong");



        }
        else{
        console.log("Something wrong");


        }
        })
        .catch(function (error) {
        console.log(error);
        });

    }

    back=()=>
    {
      window.location="RequestBalance";
    }

    onChangetype=event=>{

      if(event.label ==='Sender_ID' || event.label ==='هوية المرسل')
      {
       type="sender_id";
         document.querySelector('.sender_request').style = 'display:block';
         document.querySelector('.balance_request').style = 'display:none';
      }
      else if(event.label ==='Balance' ||event.label ==='رصيد'){
     type="balance"
        document.querySelector('.sender_request').style = 'display:none';
        document.querySelector('.balance_request').style = 'display:block';
      }
    }
    Adv=event=>{
      if(this.state.enable === false){
        this.setState({enable:true});
    }
    else{
        this.setState({enable:false});
}
    }
  render() {
  return (
    <div className="big_div">
    <Menutest/>
    <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card request_div">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} novalidate>
                <p className="h4 text-center py-4 text_style ko7le_color" style={{ color: '#59c8c8'}}> {i18n.t('Request_balance.label')}</p>
                <p className="h6 black_color">{i18n.t('type_of_request.label')}</p>
                <Select
                          fluid
                          search
                          selection
                          options={this.state.type_request}
                          onChange={this.onChangetype.bind(this)}
                          className="type_request"
                        />
                        <br/>
                        <Select
                          fluid
                          search
                          selection
                          options={this.state.type_request_admin}
                          onChange={this.onChangetype.bind(this)}
                          className="type_request_admin"
                          style={{display:'none'}}
                        />
                        <br/>

      <div className="balance_request" style={{display:'none'}}>
      <p className="h6 black_color type_ar">{i18n.t('type.label')}</p>
                <Select
                          fluid
                          search
                          selection
                          options={this.state.type}
                          onChange={this.onChange.bind(this)}
                        />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                  className="balance_ar"
                >

                  {i18n.t('balance.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="balance"
                  onChange={this.handleChangebalance}
                />
                <br />
</div>

<div className="sender_request" style={{display:'none'}}>
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light title_req"
                >

                 {i18n.t('Request_Sender_ID.label')}

                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="requwat"
                  onChange={this.handleChange}
                  maxLength="11"
                />
                <br />
                <Checkbox label= {i18n.t('Adv.label')} style={{width:'20%,white-space: pre;'}} onClick={this.Adv}  style={{ width: '34%'}}/>

                <br />
</div>
                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_azr2_fate7">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_azr2_fate7">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div></div></div>
  );
}
};
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (AddRequestBalance);
